module.exports = __webpack_public_path__ + "img/0Q3B3814-26_H_FoamcoreMatted_MockedUp.996f00f1.jpg";